import template from './location_distance.all.html'
import controller from './location_distance.all.controller'
import './location_distance.all.scss'

const locationDistanceAllComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default locationDistanceAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/location_distance/all/location_distance.all.component.js